const PersonalHome = r => require.ensure([], () => r(require('./../components/personal/home/Home.vue')), 'personalHome');
// 签约管理
const Sign = r => require.ensure([], () => r(require('./../components/personal/sign/Sign.vue')), 'Sign');
const SignLoanContract = r => require.ensure([], () => r(require('./../components/personal/sign/SignLoanContract.vue')), 'SignLoanContract');
const Template = r => require.ensure([], () => r(require('./../components/personal/sign/Template.vue')), 'Template');
const Record = r => require.ensure([], () => r(require('./../components/personal/sign/Record.vue')), 'Record');
const SignHome = r => require.ensure([], () => r(require('./../components/personal/sign/SignHome.vue')), 'SignHome');
const SignDetail = r => require.ensure([], () => r(require('./../components/personal/sign/SignDetail.vue')), 'SignHome');
const SelectSign = r => require.ensure([], () => r(require('./../components/personal/sign/SelectSign.vue')), 'SignHome');
const Empty = r => require.ensure([], () => r(require('./../components/personal/Empty.vue')), 'Empty');
const SignatureContract = r => require.ensure([], () => r(require('./../components/personal/sign/components/initiateContract/Signature.vue')), 'Signature');
const CreatFqPerformance = r => require.ensure([], () => r(require('../components/personal/sign/createFqPerformance/creatPerformance.vue')), 'CreatFqPerformance');

//调解赋强签署
const SignContract = r => require.ensure([], () => r(require('./../components/personal/sign/components/initiateContract/SignContract.vue')), 'SignContract');
//赋强签署
const SignMediate = r => require.ensure([], () => r(require('./../components/personal/sign/components/initiateContract/SignatureMediate.vue')), 'SignMediate');

const SelectCertificate = r => require.ensure([], () => r(require('./../components/personal/sign/SelectCertificate.vue')), 'Signature');
const Signpay = r => require.ensure([], () => r(require('./../components/personal/sign/components/sign/pay.vue')), 'Signpay');
const complete = r => require.ensure([], () => r(require('./../components/personal/sign/complete.vue')), 'Signpay');
const contractDetils = r => require.ensure([], () => r(require('./../components/personal/sign/components/template/contractDetils.vue')), 'contractDetils');
const voucher = r => require.ensure([], () => r(require('./../components/personal/sign/Voucher.vue')), 'Signpay');
// 一般合同履约管理
const Performances = r => require.ensure([], () => r(require('./../components/personal/performance/Performance.vue')), 'Performance');
const PerformanceList = r => require.ensure([], () => r(require('./../components/personal/performance/PerformanceList.vue')), 'PerformanceList');
const ImplementationDetails = r => require.ensure([], () => r(require('./../components/personal/performance/components/performanceList/ImplementationDetails.vue')), 'ImplementationDetails');
// const Performancemession = r => require.ensure([], () => r(require('../components/personal/performance/mission.vue')), 'Performancemession');
// const InterpellationDetail = r => require.ensure([], () => r(require('../components/personal/performance/interpellationDetail.vue')), 'InterpellationDetail');
// FQ合同履约管理
const FqPerformanceList = r => require.ensure([], () => r(require('./../components/personal/FqPerformance/PerformanceList.vue')), 'FqPerformanceList');
const FqPerformanceMession = r => require.ensure([], () => r(require('../components/personal/FqPerformance/mission.vue')), 'FqPerformanceMession');
const FqInterpellationDetail = r => require.ensure([], () => r(require('../components/personal/FqPerformance/interpellationDetail.vue')), 'FqInterpellationDetail');

// 预警
const Warning = r => require.ensure([], () => r(require('./../components/personal/warning/Warning.vue')), 'Warning');
const WarningAdd = r => require.ensure([], () => r(require('./../components/personal/warning/WarningAdd.vue')), 'WarningAdd');

// 司法服务
const Service = r => require.ensure([], () => r(require('./../components/personal/service/Service.vue')), 'Service');
const ServiceHome = r => require.ensure([], () => r(require('./../components/personal/service/ServiceHome.vue')), 'Service');
const Evidence = r => require.ensure([], () => r(require('./../components/personal/service/components/Evidence.vue')), 'Evidence');
const LawyerEvidence = r => require.ensure([], () => r(require('./../components/personal/service/components/lawyerEvidence.vue')), 'LawyerEvidence');

const Procedure = r => require.ensure([], () => r(require('./../components/personal/service/components/procedure.vue')), 'Procedure');
const WriteProcedure = r => require.ensure([], () => r(require('./../components/personal/service/components/writeProcedure.vue')), 'WriteProcedure');
// 赋强公证列表
const FqDataDetails = r => require.ensure([], () => r(require('./../components/personal/service/components/writeProcedure/fqProcedure/DataDetail.vue')), 'DataDetails');
const NotarialDetails = r => require.ensure([], () => r(require('./../components/personal/service/components/writeProcedure/fqProcedure/NotarialDetails.vue')), 'NotarialDetails');
const FqCertificate = r => require.ensure([], () => r(require('./../components/personal/service/components/writeProcedure/fqProcedure/fqCertificate.vue')), 'FqCertificate');
const LookFqCeryificate = r => require.ensure([], () => r(require('./../components/personal/service/components/writeProcedure/fqProcedure/lookFqCeryificate.vue')), 'LookFqCeryificate');
const LawyerCertificate = r => require.ensure([], () => r(require('./../components/personal/service/components/certificate/lawyerCertificate.vue')), 'LawyerCertificate');
const JudicialCertificate = r => require.ensure([], () => r(require('./../components/personal/service/components/certificate/judicialCertificate.vue')), 'judicialCertificate');

//强执公证
const UrgeCertificate = r => require.ensure([], () => r(require('./../components/personal/service/components/writeProcedure/fqExecution/urgeCertificate.vue')), 'UrgeCertificate');
const UrgeCertificateShare = r => require.ensure([], () => r(require('./../components/common/urgeCertificateShare.vue')), 'UrgeCertificateShare');

//合同公证
const NotarialDetail = r => require.ensure([], () => r(require('./../components/personal/service/components/writeProcedure/NotarialDetails.vue')), 'NotarialDetail');
const DataDetail = r => require.ensure([], () => r(require('./../components/personal/service/components/writeProcedure/DataDetail.vue')), 'DataDetail');

// 个人中心
const SetLoginPwd = r => require.ensure([], () => r(require('./../components/personal/user/components/safety/SetloginPwd.vue')), 'SetLoginPwd');
const AmendLoginpwd = r => require.ensure([], () => r(require('./../components/personal/user/components/safety/AmendLoginpwd.vue')), 'AmendLoginpwd');
const SetSignPwd = r => require.ensure([], () => r(require('./../components/personal/user/components/safety/SetsignPwd.vue')), 'SetSignPwd');
const AmendSignPwd = r => require.ensure([], () => r(require('./../components/personal/user/components/safety/AmendSignPwd.vue')), 'AmendSignPwd');
const Cost = r => require.ensure([], () => r(require('./../components/personal/user/Cost.vue')), 'Cost');
const Pay = r => require.ensure([], () => r(require('./../components/personal/user/components/cost/Pay.vue')), 'Pay');
const Signature = r => require.ensure([], () => r(require('./../components/personal/user/Signature.vue')), 'Signature');
const Authorization = r => require.ensure([], () => r(require('./../components/personal/user/Authorization.vue')), 'Authorization');
const Signatory = r => require.ensure([], () => r(require('./../components/personal/user/Signatory.vue')), 'Signatory');
const UserHome = r => require.ensure([], () => r(require('./../components/personal/user/UserHome.vue')), 'UserHome');
const AuthorizedHistory = r => require.ensure([], () => r(require('./../components/personal/user/AuthorizedHistory.vue')), 'AuthorizedHistory');
const PersonalCertificate = r => require.ensure([], () => r(require('./../components/personal/user/PersonalCertificate.vue')), 'PersonalCertificate');
const Enterprise = r => require.ensure([], () => r(require('./../components/personal/user/Enterprise.vue')), 'Enterprise');
const EnterpriseSupplement = r=>require.ensure([], () => r(require('./../components/personal/user/EnterpriseSupplement.vue')), 'EnterpriseSupplement');

//支付方式页面
const Payment = r => require.ensure([], () => r(require('./../components/personal/payment/index.vue')), 'Payment');

// 组织管理
const Employee = r => require.ensure([], () => r(require('./../components/personal/organization/employee.vue')), 'Employee');

export default {
  path: '',
  component: Empty,
  children: [
    // 首页
    {
      path: 'home',
      component: PersonalHome,
    },
    // 签约管理
    {
      path: 'sign/home',
      component: SignHome,
    },
    //普通合同发起
    {
      path: 'sign/index',
      component: Sign,
      name: 'signIndex'
    },
    //赋强合同签约
    {
      path: 'sign/signLoanIndex',
      component: SignContract
    },
    //调解赋强合同签约
    {
      path: 'sign/signMediate',
      component: SignMediate
    },
    //赋强合同发起
    {
      path: 'sign/signLoanContract',
      component: SignLoanContract
    },
    // 普通签约
    {
      path: 'sign/index/signature',
      component: SignatureContract,
    },
    {
      path: 'sign/template',
      component: Template,
    },
    {
      path: 'sign/record',
      component: Record,
    },
    {
      path: 'sign/detail',
      component: SignDetail,
    },
    {
      path: 'sign/selectSign',
      component: SelectSign,
    },
    {
      path: 'sign/selectCertificate',
      component: SelectCertificate,
    },
    {
      path: 'sign/complete',
      component: complete,
    },
    {
      path: 'sign/contractDetils',
      component: contractDetils
    },
    {
      path: 'sign/pay.html',
      name: 'Signpay',
      component: Signpay
    },
    {
      path: 'sign/voucher',
      name: 'Signpay',
      component: voucher
    },
    {
      path: 'sign/creatFqPerformance',
      name: 'creatFqPerformance',
      component: CreatFqPerformance
    },
    // 履约管理
    {
      path: 'performance/index',
      component: Performances,
    },
    {
      path: 'performance/details',
      component: ImplementationDetails
    },
    // {
    //   path: 'performance/mission',
    //   component: Performancemession
    // },
    // {
    //   path: 'performance/interpellationDetail',
    //   component: InterpellationDetail
    // },
    {
      path: 'performance/list',
      component: PerformanceList,
    },
    /**
     * FQ合同履约
     */
    {
      path: 'fqPerformance/list',
      component: FqPerformanceList,
    },
    {
      path: 'fqPerformance/mission',
      component: FqPerformanceMession
    },
    {
      path: 'fqPerformance/interpellationDetail',
      component: FqInterpellationDetail
    },
    // 预警
    {
      path: 'warning/index',
      component: Warning,
    },
    {
      path: 'warning/add',
      component: WarningAdd,
    },
    // 司法服务
    {
      path: 'service',
      component: Service,
    },
    {
      path: 'serviceHome',
      component: ServiceHome,
    },
    {
      path: 'service/loan', // 贷款赋强
      component: ServiceHome,
      name: 'serviceLoan'
    },
    {
      path: 'service/conciliation', // 调解赋强
      component: ServiceHome,
      name: 'serviceConciliation'
    },
    {
      path: 'serviceHome/evidence',
      component: Evidence,
    },
    {
      path: 'serviceHome/lawyerEvidence',
      component: LawyerEvidence
    },
    {
      path: 'serviceHome/evidence/procedure',
      component: Procedure,
    },
    //公证服务
    {
      path: "serviceHome/writeProcedure",
      name: 'Describe',
      component: WriteProcedure
    },
    //赋强公证-证据详情
    {
      path: "serviceHome/writeProcedure/fqDataDetail",
      component: FqDataDetails
    },
    //赋强公证-公证详情
    {
      path: "serviceHome/writeProcedure/fqNotarialDetail",
      component: NotarialDetails
    },
    //赋强存证证据预览
    {
      path: "serviceHome/writeProcedure/lookFqCeryificate",
      component: LookFqCeryificate
    },
    {
      path: "serviceHome/fqCertificate",
      component: FqCertificate
    },
    {
      path: 'serviceHome/evidence/lawyerCertificate',
      component: LawyerCertificate
    },
    {
      path: "serviceHome/evidence/judicialCertificate",
      component: JudicialCertificate
    },
    //强执公证-查看短信、邮件催告
    {
      path: "serviceHome/urgeCertificate",
      component: UrgeCertificate
    },
    //强执公证-查看短信、邮件催告部分抽离出来
    {
      path: "serviceHome/urgeCertificateShare",
      component: UrgeCertificateShare
    },
    //合同公证-公证详情
    {
      path: "serviceHome/writeProcedure/NotarialDetail",
      component: NotarialDetail
    },
    //合同公证-证据详情
    {
      path: "serviceHome/writeProcedure/DataDetail",
      component: DataDetail
    },
    // 个人中心
    {
      path: 'users/home',
      name: 'userHome',
      component: UserHome,
    },
    {
      path: 'users/safety/setLoginPwd',
      component: SetLoginPwd
    },

    {
      path: 'users/safety/amendLoginpwd',
      component: AmendLoginpwd
    },
    {
      path: 'users/safety/setSignPwd',
      component: SetSignPwd
    },
    {
      path: 'users/safety/amendSignPwd',
      component: AmendSignPwd
    },
    {
      path: 'users/cost',
      component: Cost,
    },
    {
      path: 'users/cost/pay',
      name: "pay",
      component: Pay,
    },
    {
      path: 'users/signature',
      component: Signature,
    },
    {
      path: 'users/authorization',
      component: Authorization,
    },
    {
      path: 'users/signatory',
      component: Signatory,
    },
    {
      path: 'users/authorizedHistory',
      component: AuthorizedHistory,
    },
    {
      path: 'users/PersonalCertificate',
      name:"personalCertificate",
      component: PersonalCertificate,
    },
    {
      path: "users/enterprise",
      name:"enterprise",
      component: Enterprise
    },
    //机构材料补充页
    {
      path: "users/enterpriseSupplement",
      name:"enterpriseSupplement",
      component: EnterpriseSupplement
    },
    //支付页面
    {
      path:"payment",
      component:Payment
    },
    //组织管理
    {
      path:"organization/employee",
      component:Employee
    },
  ]
}